import { cn } from "@gigpro/ui/tailwind/cn";
import { Label as LabelPrimitive } from "radix-ui";
import type * as React from "react";

interface LabelProps extends React.ComponentProps<typeof LabelPrimitive.Root> {
  optional?: boolean;
}

const Label = ({ ref, className, children, optional, ...props }: LabelProps) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      "inline-flex w-full items-center gap-1 truncate text-normal font-semibold text-black peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className,
    )}
    {...props}
  >
    {children}
    {optional && <span className="ml-1 font-regular text-medium-gray">(optional)</span>}
  </LabelPrimitive.Root>
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
